export const routeConfig = {
    menus: [
        {
            key: '/',
            title: '母版页面',
            component: 'DefaultLayout',
            subs: [
                { key: '', title: '首页', component: 'AppPage' },
                { key: '/index', title: '首页', component: 'AppPage' },
                { key: '/dev', title: '测试页面', component: 'DevPage' },
                { key: '/blog', title: '文章', component: 'BlogPage' },
                { key: '/about', title: '关于我们', component: 'AboutPage' },
                { key: '/contact', title: '联系我们', component: 'ContactPage' },
            ]
        }
    ]
};